import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative [--slide-size:auto] [--slide-spacing:0]',
    viewport: 'overflow-hidden',
    container: 'ml-[calc(var(--slide-spacing)*-1)] flex',
    arrow: 'text-text-main border-0 hover:bg-none',
    slide:
      'flex w-[var(--slide-size,auto)] shrink-0 grow-0 pl-[var(--slide-spacing)]',
    dots: 'flex justify-center gap-1',
    dot: 'h-[2px] w-[18px] cursor-pointer rounded-full transition-all duration-300',
    bottomControls:
      'relative m-auto hidden max-w-[85%] items-center justify-between pt-[32px] pb-[40px] lg:flex lg:max-w-[70%]',
    bottomControlsButtons:
      'flex h-[40px] w-[104px] items-center justify-between gap-[24px]',
    bottomControlsDots: '',
    bottomControlsItems: '',
    bottomDots: 'flex items-center gap-[16px] pl-0! lg:pl-0!',
    bottomDot: 'rounded-[100px]'
  },
  variants: {
    active: {
      true: {
        dot: 'bg-brand-primary',
        bottomDot: 'bg-brand-primary h-[8px] w-[8px]'
      },
      false: {
        dot: 'bg-[#F0F0F0] opacity-30',
        bottomDot: 'h-[4px] w-[4px] bg-[#D1D5DB]'
      }
    },
    disabled: {
      true: {
        arrow: 'hidden'
      }
    }
  }
});
